

























































import { Component, Prop, Vue } from "vue-property-decorator";

import DropdownControlIcon from "@share/common/icons/DropdownControlIcon.vue";
import DatePickerRange from '@share/common/form/form-controls/date/date-picker-range/DatePickerRange.vue';
import SingleSelect from "@share/common/form/form-controls/select/variations/single-select/SingleSelect.vue";

import { TicketReportHelper } from "@share/ticketSystem/components/reports/services/TicketReportHelper";
import { TicketService } from "@share/common/services/ticket/TicketService";
import { TicketType } from "@share/ticketSystem/enums/TicketTypes";
import { ReportType } from "@share/ticketSystem/enums/ReportType";

import SingleSelectS01 from "@share/common/form/form-controls/select/variations/single-select-s01/SingleSelect-S01.vue";
import { TicketTableHelper } from "@share/ticketSystem/helpers/TicketTableHelper";
import { Notice } from "@service/components/toast/type/Notice";
import { NoticeLevel } from "@service/components/toast/type/Enums";
import { noticeActions } from "@service/store/notice/actions";

import DarkModalWindow from "@service/components/modal/DarkModal.vue";
import { showErrorModal, showNeedRightsModal } from "@service/helpers/ErrorModals";

import { createMachine, interpret } from 'xstate';
import { AxiosError, AxiosResponse } from "axios";
import { BackendErrorInterface } from "@api/models/interfaces/BackendError";
import { ObjectFields, ReportId, ReportState, TicketReport } from "@share/ticketSystem/components/reports/types";
import { SelectObjectSourceService } from "@share/common/services/selectControl/SelectObjectSourceService";
import { SelectDataService } from "@share/ticketSystem/components/reports/services/TicketReportSelectDataService";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { DropDownItem } from "@share/common/drop-down/types";
import { DatePickerRangeDataInterface, ReportFilterState } from "./types";
import { DateTime } from "luxon";
import { required } from "vuelidate/lib/validators";

enum Event {
    send = "SEND",
    reset = "RESET"
}

enum State {
    main = "main",
    sent = "sent",
    error = "error"
}

const stateMachine = createMachine({
    id: 'ticket-report',
    initial: 'main',
    states: {
        main: {
            on: {
                [Event.send]: 'sent'
            }
        },
        sent: {
            on: { [Event.reset]: 'main' }
        }
    }
})

@Component({
    components: { DropdownControlIcon, SingleSelectS01, DarkModalWindow, DatePickerRange, SingleSelect }
})

export default class TicketsReports extends Vue {
    @Prop({required: true}) ticketHelper: TicketTableHelper;
    @Prop({required: true}) ticketService: TicketService;
    @Prop({required: true}) ticketType: TicketType;

    private readonly COMPANY_SCHEMA_ID = process.env.VUE_APP_COMPANY_STRUCTURE_SCHEMA || 'CompanyStructure';

    ticketReportHelper: TicketReportHelper;

    reportState: ReportState = {
        selectedReportId: "reportIL1"
    }

    stateService = interpret(stateMachine);
    currentState = stateMachine.initialState;

    dateRangeValidations = { start: { required }, end: { required } }

    createdAt: DatePickerRangeDataInterface = { 'start': '', 'end': '' }
    company: DropDownItem = { id: "", title: "" };
    branch: DropDownItem = { id: "", title: "" };
    direction: DropDownItem = { id: "", title: "" };

    State = State;

    // SERVICES:
    selectObjectDataService: SelectDataService<ObjectFields> | null = null;

    created() {
        //set default report
        this.reportState.selectedReportId = this.ticketType === TicketType.idea ? "reportIL1" : "reportPL1";

        // Start service on component creation
        this.stateService
            .onTransition((state) => {
                // Update the current state component data property with the next state
                this.currentState = state;
            })
            .start();
        //create after show
        this.ticketReportHelper = new TicketReportHelper(
            this.reportState,
            this.ticketService
        );

        this.selectObjectDataService = new SelectDataService<ObjectFields>(
            new SelectObjectSourceService(this.$repositories.get(RepositoryFabric.OBJECT))
        );
    }

    reset() {
        this.stateService.send(Event.reset);
    }

    selectReport(id: ReportId) {
        this.reportState.selectedReportId = id;

        if (id === "reportIW1" || id === "reportPW1") {
            this.setDates()
        }
    }

    closeModal() {
        this.$emit('close');
    }

    companySearch(keyword = "") {
        this.selectObjectDataService?.updateSource("company", { keyword, schemaId: this.COMPANY_SCHEMA_ID });
    }

    branchSearch(keyword = "") {
        this.company.id && this.selectObjectDataService?.updateSource("branch", { keyword, schemaId: this.COMPANY_SCHEMA_ID, parentsIds: [this.company.id] });
    }

    directionSearch(keyword = "") {
        let parentId = "";

        if(this.branch.id) {
            parentId = this.branch.id;
        }
        else if(this.company.id) {
            parentId = this.company.id;
        }

        if(parentId) {
            this.selectObjectDataService?.updateSource("direction", { keyword, schemaId: this.COMPANY_SCHEMA_ID, parentsIds: [parentId] });
        }
    }

    get reportsObject(): Record<string, TicketReport> {
        return this.ticketReportHelper.getReportsList(this.ticketType);
    }

    get reportsList(): any[] {
        return Object.entries(this.reportsObject).map(item => {
            return {
                id: item[0],
                ...item[1]
            }
        });
    }

    get selectedReport() {
        return this.reportsObject[this.reportState.selectedReportId]
    }

    get email() {
        return this.$store.getters.profile?.email ?? 'unknown profile';
    }

    getFilterState(): ReportFilterState {
        return {
            createdAt: this.createdAt,
            company: this.company,
            branch: this.branch,
            direction: this.direction
        }
    }

    async makeReport() {
        const filter = this.getFilterState();

        try {
            const query = await this.ticketReportHelper.getQuery(filter);

            if(this.selectedReport?.reportType === ReportType.count) {
                await this.ticketService.sendTicketsCountToEmail(this.ticketType, this.selectedReport.title, query);
            }
            else if(this.selectedReport?.reportType === ReportType.givenAndAccepted) {
                await this.ticketService.sendGivenAndAcceptedToEmail(this.ticketType, this.selectedReport.title, query);
            }
            //WEEKLY:
            else if (this.selectedReport?.reportType === ReportType.weekly) {

                (this.$refs["datePickerRange"] as DatePickerRange | undefined)?.validate();

                if (!filter.createdAt.start || !filter.createdAt.end) {
                    return
                }

                const params = this.getWeeklyParams(this.selectedReport.title, filter.createdAt);
                await this.ticketService.sendWeeklyTicketsToEmail(this.ticketType, params, query);
            }
            else {
                await this.ticketService.sendTicketsToEmail(this.ticketType, this.selectedReport.title, query);
            }

            const notice: Notice = {
                text: this.$t("tickets.exportEmailSentSuccessfully").toString(),
                level: NoticeLevel.success
            }

            this.$store.dispatch(noticeActions.submitNotice, notice);
            this.stateService.send(Event.send);
        }
        catch(e) {
            const { response } = e as AxiosError<BackendErrorInterface>;
            this.handleError(response, e);
        }
    }

    handleError(response: AxiosResponse<BackendErrorInterface> | undefined, e: unknown) {
        switch (response?.data.code) {
            case "tickets.noEmail":
                showErrorModal(this.$t("tickets.emailError").toString())
                break;

            case "tickets.wrongConfiguration":
                showErrorModal(this.$t("tickets.missingCollectionError").toString())
                this.$store.dispatch('reportError', e);
                break;

            case "noElements":
                showErrorModal(this.$t("tickets.noItemsFound").toString())
                break;

            case "needRights":
                showNeedRightsModal()
                break;

            default:
                showErrorModal(this.$t("common.errorTitle").toString())
                this.$store.dispatch('reportException', e);
                break;
        }
    }

    private setDates() {
        if (!this.createdAt.start && !this.createdAt.end) {
            const end = DateTime.local().endOf("day");
            const start = end.minus({ months: 1 }).startOf("day");

            this.createdAt.start = start.toISO();
            this.createdAt.end = end.toISO();
        }
    }

    private getWeeklyParams(title: string | undefined, period: DatePickerRangeDataInterface) {
        return {
            subject: title,
            periodStartDate: period.start,
            periodEndDate: period.end
        }
    }
}

